import { useEffect, useRef } from 'react';

/**
 * Runs `reset` when the pair changes — not on mount, and not when the same
 * coin is re-selected. Chart overlays are per pair: what a trader asked to
 * see on BTC is not what they asked to see on ZEC, so a switch turns them
 * off and the trader opts in again on the new pair.
 */
export function useResetOnPairSwitch(coin: string, reset: () => void): void {
    const prevRef = useRef(coin);
    useEffect(() => {
        if (prevRef.current === coin) return;
        prevRef.current = coin;
        reset();
    }, [coin, reset]);
}
